import {
    ActionCreatorProps,
    createAction,
    props
} from '@ngrx/store';
import {
    DATIQ_APP,
    DatiqAppConfig,
    IDatiqAnalyticsEvent,
    IDatiqLink,
    IDatiqRoute,
} from '@dat/datiq-core/models';

const createActionName: (name: string) => string = (name: string) => {
    return `[${DATIQ_APP}] ${name}`;
};
const createErrorActionName: (name: string) => string = (name: string) => {
    return `[Datiq Error] ${name}`;
};
const defaultAnalyticProps: ActionCreatorProps<IDatiqAnalyticsEvent> =
    props<IDatiqAnalyticsEvent>();

export const init = createAction(createActionName('Initialize'));
export const loaded = createAction(
    createActionName('Loaded'),
    props<{ config: DatiqAppConfig }>(),
);
export const loading = createAction(createActionName('Loading'));
export const noAccessRoute = createAction(
    createActionName('Re-Route No Access Route'),
    props<{ noAccessLink: IDatiqLink }>(),
);
export const noAccessRouteSuccess = createAction(
    createActionName('Re-Route No Access Route Success'),
);
export const noActionFired = createAction(
    createActionName('No Action Fired'),
    props<{ message?: string }>(),
);
export const loadingError = createAction(
    createActionName('Loading Error'),
    props<any>(),
);
export const errorActionFiredName = createErrorActionName('fired');
export const errorActionFired = createAction(
    errorActionFiredName,
    defaultAnalyticProps,
);
export const setRoute = createAction(
    createActionName('Set Route'),
    props<{ route: IDatiqRoute }>(),
);
export const navigateToRoute = createAction(
    createActionName('Navigate to Route'),
    props<{ path: string[] }>(),
);
export const navigateToRouteSuccess = createAction(
    createActionName('Navigate to Route Success'),
    props<{ path: string[] }>(),
);
export const navigateToUrl = createAction(
    createActionName('Navigate to Url'),
    props<{ link: IDatiqLink }>(),
);
export const navigateToUrlSuccess = createAction(
    createActionName('Navigate to Url Success'),
    props<{ link: IDatiqLink }>(),
);
export const lockCurrentRoute = createAction(
    createActionName('Lock Current Route'),
);
export const unlockCurrentRoute = createAction(
    createActionName('Unlock Current Route'),
);
